import remote from "../../../../services/remote";
import {
    getDailyReportDataSuccess,
    getDailyReportDataFailure,
    updateReportNotesSuccess,
    updateReportNotesFailure,
    exportDocSuccess,
    exportDocFailure, getAllDailyReportDataFailure,getAllDailyReportDataSuccess
} from "./actions";
import {GET_DAILY_REPORT_DATA, UPDATE_REPORT_NOTES, EXPORT_DOC, GET_ALL_REPORTS_DATA} from "./constants";
import {call, put, takeLatest} from "redux-saga/effects";
import SentryManager from "../../../../monitoring/Sentry";

function* getDailyReportData (action) {
    try {
        const response = yield call(remote, {
            route: `/admin/bookings/get-report-data`,
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(getDailyReportDataSuccess(response.data));
        } else {
            yield put(getDailyReportDataFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* getAllDailyReportsData (action) {
    try {
        const response = yield call(remote, {
            route: `/admin/bookings/get-report-data`,
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(getAllDailyReportDataSuccess(response.data));
        } else {
            yield put(getAllDailyReportDataFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* updateReportNotes (action) {
    try {
        const response = yield call(remote, {
            route: `/admin/bookings/update-report-notes/${action.data.bookingId}`,
            method: 'put',
            body: JSON.stringify({report_notes: action.data.reportNote})
        });
        if (response.success) {
            yield put(updateReportNotesSuccess(response.data));
        } else {
            yield put(updateReportNotesFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* exportDoc (action) {
    try {
        const response = yield call(remote, {
            route: `/admin/bookings/post-report-doc`,
            method: 'post',
            body: JSON.stringify({reportType: action.data.type, filterOptions: action.data.filterOptions})
        });
        if (response.success) {
            yield put(exportDocSuccess(response.data));
        } else {
            yield put(exportDocFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

export default function* watchDailyReports() {
    yield takeLatest(GET_DAILY_REPORT_DATA , getDailyReportData);
    yield takeLatest(GET_ALL_REPORTS_DATA , getAllDailyReportsData);
    yield takeLatest(UPDATE_REPORT_NOTES , updateReportNotes);
    yield takeLatest(EXPORT_DOC , exportDoc);
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/DailyReport/saga.js